const clipsOverflow = (element: HTMLElement) => {
  const { overflow, overflowX, overflowY } = window.getComputedStyle(element);
  return [overflow, overflowX, overflowY].some((value) => value !== '' && value !== 'visible');
};

const clipsPopups = (modalBody: HTMLElement) => {
  let node: HTMLElement | null = modalBody;
  // .ant-modal is the outermost element that scrolls with the trigger, so stop there.
  while (node && !node.classList.contains('ant-modal')) {
    if (clipsOverflow(node)) return true;
    node = node.parentElement;
  }
  return false;
};

// rc-align re-aligns popups on resize but never on scroll, so a popup mounted on document.body
// drifts away from a trigger that scrolls with .ant-modal-wrap. Mounting it in the modal makes the
// two scroll together, except where the modal clips its overflow and would cut the popup off.
export const getModalPopupContainer = (triggerNode?: HTMLElement | null): HTMLElement => {
  const modalBody = triggerNode?.closest?.('.ant-modal-body') as HTMLElement | null;

  return modalBody && !clipsPopups(modalBody) ? modalBody : document.body;
};
